export function getBreakpointsValues<T>(
  width: number,
  options: { [key: string]: T }
): T {
  const breakpoints = Object.keys(options).map(Number);
  breakpoints.sort((a: number, b: number) => b - a);

  const lastItem = breakpoints[breakpoints.length - 1];

  const currentBreakpoint =
    breakpoints.find((breakpoint) => width >= breakpoint) ?? lastItem;

  return options[currentBreakpoint];
}
